import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import axios from "axios";
import { useHistory } from "react-router-dom";
import PageWrapper from "../components/PageWrapper/PageWrapper";
import ProductList from "../components/products/ProductList";
import RecentlySoldBanner from "../components/RecentlySoldBanner";
import DiscountPopup from "../components/DiscountPopup";
import bannerImage from "../assets/rdb.jpg";
import { getAddresses } from "../api/apiServices";

const Homepage = () => {
  const [discountPopupOpen, setDiscountPopupOpen] = useState(false);
  const [activeDiscountBannerImageUrl, setActiveDiscountBannerImageUrl] =
    useState(null);
  const [activeDiscountBannerUrl, setActiveDiscountBannerUrl] = useState(null);
  const [exclusivelyAvailableProducts, setExclusivelyAvailableProducts] = useState([]);
  const [premiumProducts, setPremiumProducts] = useState([]);
  const [comingSoonProducts, setComingSoonProducts] = useState([]);
  const [bestsellersProducts, setBestsellersProducts] = useState([]);
  const [liquidsProducts, setLiquidsProducts] = useState([]);
  const [recentlyAddedProducts, setRecentlyAddedProducts] = useState([]);
  const [bobbysCornerProducts, setBobbysCornerProducts] = useState([]);
  const [rareComboProducts, setRareComboProducts] = useState([]);
  const [combinationsProducts, setCombinationsProducts] = useState([]);
  const [prebookingProducts, setPrebookingProducts] = useState([]);
  const [compilationProducts, setCompilationProducts] = useState([]);
  const [latestReleasesProducts, setLatestReleasesProducts] = useState([]);
  const [onDiscountProducts, setOnDiscountProducts] = useState([]);
  const [preOwnedProducts, setPreOwnedProducts] = useState([]);
  const [recentlySoldItems, setRecentlySoldItems] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    checkAddressAndFetchProducts();
    fetchActiveDiscountBanner();
  }, []);

  const checkAddressAndFetchProducts = async () => {
    try {
      const addressResponse = await getAddresses();
      const addresses = Array.isArray(addressResponse?.data?.success)
        ? addressResponse.data.success
        : Array.isArray(addressResponse?.data?.data)
          ? addressResponse.data.data
          : [];
      if (addresses.length === 0 && localStorage.getItem("userId")) {
        history.replace("/addaddress");
        return;
      }
      fetchAllProducts();
    } catch (error) {
      console.error("Error fetching addresses:", error);
      fetchAllProducts();
    }
  };

  const fetchActiveDiscountBanner = async () => {
    try {
      const auth = localStorage.getItem("authToken");
      const headers = auth ? { Authorization: `Bearer ${auth}` } : {};

      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/banner/getall`,
        { headers }
      );

      const banners = res.data?.data;
      if (!Array.isArray(banners) || banners.length === 0) return;

      const activeBanners = banners.filter(
        (b) => b?.status === 1 || b?.status === true
      );
      if (activeBanners.length === 0) return;

      const activeBanner = [...activeBanners].sort((a, b) => {
        const aTime = new Date(a?.updated_at || a?.created_at || 0).getTime();
        const bTime = new Date(b?.updated_at || b?.created_at || 0).getTime();
        return bTime - aTime;
      })[0];

      if (activeBanner?.path) {
        const imageUrl = `https://pancham-bucket.s3.amazonaws.com/${activeBanner.path}`;
        setActiveDiscountBannerImageUrl(imageUrl);
        setActiveDiscountBannerUrl(activeBanner.banner_url || null);
        setDiscountPopupOpen(true);
      }
    } catch (error) {
      console.log("Error fetching active discount banner:", error);
      // If banner fetch fails, don't block homepage.
    }
  };

  const fetchAllProducts = async () => {
    try {
      setLoading(true);
      const auth = localStorage.getItem("authToken");
      const headers = auth ? { Authorization: `Bearer ${auth}` } : {};
      const tags = [
        {
          tag: "Exclusive",
          combo: "",
          count: 10,
          setter: setExclusivelyAvailableProducts,
        },
        {
          tag: "Coming Soon",
          combo: "",
          count: 10,
          setter: setComingSoonProducts,
        },
        {
          tag: "Bestseller",
          combo: "",
          count: 10,
          setter: setBestsellersProducts,
        },
        {
          tag: "On Discount",
          combo: "",
          count: 10,
          setter: setOnDiscountProducts,
        },
        {
          tag: "Prebooking",
          combo: "",
          count: 10,
          setter: setPrebookingProducts,
        },
        {
          tag: "Latest Releases",
          combo: "",
          count: 10,
          setter: setLatestReleasesProducts,
        },
        {
          tag: "Premium",
          combo: "",
          count: 10,
          setter: setPremiumProducts,
        },
        {
          tag: "Rare",
          combo: "true",
          count: 10,
          setter: setRareComboProducts,
        },
        {
          tag: "Combo",
          combo: "true",
          count: 10,
          setter: setCombinationsProducts,
        },
        {
          tag: "",
          combo: "",
          count: 10,
          category: "Compilation",
          setter: setCompilationProducts,
        },
        {
          count: 10,
          condition_type: "Preowned",
          setter: setPreOwnedProducts,
        },
        {
          tag: "liquids",
          combo: "",
          count: 10,
          setter: setLiquidsProducts,
          isLiquid: true,
        },
        { tag: "", combo: "", count: 10, setter: setRecentlyAddedProducts },
        // { tag: "", combo: "", count: 10, setter: setRecentlySoldItems },
      ];

      const productPromises = tags.map(
        async ({
          tag,
          combo,
          count,
          setter,
          isLiquid,
          category,
          condition_type,
        }) => {
          let res;
          if (isLiquid) {
            res = await axios.post(
              `${process.env.REACT_APP_BASEURL}/admin/product/getrecentproducts`,
              { product_type: "Liquid", count: 3 },
              { headers }
            );
          } else {
            res = await axios.post(
              `${process.env.REACT_APP_BASEURL}/admin/product/getallproduct`,
              { tag, count, combo, category, condition_type },
              { headers }
            );
          }

          if (res.data?.success && res.data?.data) {
            const raw = res.data.data;
            const list = Array.isArray(raw) ? raw : typeof raw === "object" ? Object.values(raw) : [];
            const items = list.filter((item) => (item?.qty_available ?? 0) > 0);
            setter(items);
          } else {
            if (res.data.data === "no record found") {
              // enqueueSnackbar(res.data.data, { variant: "info" });
            } else {
              console.log("Error Occurred");
              // enqueueSnackbar(res.data.message, { variant: "error" });
            }
          }
        }
      );
      await fetchRecentlySold();
      await Promise.all(productPromises);

    } catch (error) {
      console.log(error);
      enqueueSnackbar("Error occurred. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchRecentlySold = async () => {
    try {
      const auth = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/product/last10sold`,
        { headers: auth ? { Authorization: `Bearer ${auth}` } : {} }
      );
      const raw = res.data?.data ?? res.data;
      if (raw) {
        const list = Array.isArray(raw) ? raw : Object.values(raw);
        setRecentlySoldItems(list.slice(0, 10));
      }
    } catch (err) {
      // API may not exist yet; banner will not show
    }
  };

  return (
    <>
      <DiscountPopup
        open={discountPopupOpen}
        onClose={() => setDiscountPopupOpen(false)}
        imageUrl={activeDiscountBannerImageUrl}
        bannerUrl={activeDiscountBannerUrl}
      />
      <PageWrapper>
        <RecentlySoldBanner items={recentlySoldItems} />
        <ProductList products={exclusivelyAvailableProducts} name="Exclusively Available With Us" />
        <ProductList products={comingSoonProducts} name="Coming Soon" />
        <ProductList products={prebookingProducts} name="Prebooking" />
        <ProductList products={latestReleasesProducts} name="Latest Releases" />
        <ProductList products={bestsellersProducts} name="Bestseller" />
        <ProductList products={preOwnedProducts} name="Pre-Owned and Old Pressings" />
        <ProductList products={rareComboProducts} name="Rare Titles" />
        <ProductList products={combinationsProducts} name="Combinations Titles" />
        <ProductList products={compilationProducts} name="Compilations Titles" />
        <ProductList products={onDiscountProducts} name="On Discount/Special Offer" />
        <ProductList products={premiumProducts} name="Premium Titles" />
        <ProductList products={recentlyAddedProducts} name="Recently Added" />
        <ProductList products={liquidsProducts} name="Pancham Vinyl Record Cleaner" hideButton />
      </PageWrapper>
    </>
  );
};

export default Homepage;
